/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { actionCreatorFactory } from 'typescript-fsa';
import { Song } from '../../../services/playlist';

const actionCreator = actionCreatorFactory();

export const SET_SONG_LIST = 'SET_SONG_LIST';
export const setSongList = actionCreator<Song[]>(SET_SONG_LIST);

export const SET_SONG_SEARCH = 'SET_SONG_SEARCH';
export const setSongSearch = actionCreator<string>(SET_SONG_SEARCH);

export const SET_SONG_SEARCH_CURRENT_POS = 'SET_SONG_SEARCH_CURRENT_POS';
export const setSongSearchCurrentPos = actionCreator<number>(SET_SONG_SEARCH_CURRENT_POS);

export const SET_SONG_SEARCH_COUNT = 'SET_SONG_SEARCH_COUNT';
export const setSongSearchCount = actionCreator<number>(SET_SONG_SEARCH_COUNT);

export const SEARCH_SONG = 'SEARCH_SONG';
export const searchSong = actionCreator(SEARCH_SONG);

export const SONG_LIST_FORWARD = 'SONG_LIST_FORWARD';
export const songListForward = actionCreator(SONG_LIST_FORWARD);

export const SONG_LIST_BACKWARD = 'SONG_LIST_BACKWARD';
export const songListBackward = actionCreator(SONG_LIST_BACKWARD);

export const SONG_LIST_FAST_FORWARD = 'SONG_LIST_FAST_FORWARD';
export const songListFastForward = actionCreator(SONG_LIST_FAST_FORWARD);

export const SONG_LIST_FAST_BACKWARD = 'SONG_LIST_FAST_BACKWARD';
export const songListFastBackward = actionCreator(SONG_LIST_FAST_BACKWARD);

export const SONG_LIST_SEARCH = 'SONG_LIST_SEARCH';
export const songListSearch = actionCreator<string>(SONG_LIST_SEARCH);

export const SONG_LIST_SET_LOADING = 'SONG_LIST_SET_LOADING';
export const songListSetLoading = actionCreator<boolean>(SONG_LIST_SET_LOADING);
